module.exports = __webpack_public_path__ + "static/img/sg.2a7ec0a7.svg";